import Form from 'react-bootstrap/Form';
import Navbar from "./Navbar";
import { InputGroup, Toast } from 'react-bootstrap';
import { useState } from 'react';
import Adsense from './Adsense';

function Contact() {
    const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });
   const [show, setShow] = useState(false);

    const handleSubmit = (e) => {
    setFormData({
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
      });
        setShow(true);
  };
  return (
    <>
      <div className="main">
        <div className="main-div2">
            <div className="container">
            <div className="mt-3">
                <Navbar/>
            </div>
            <div className="mt-5 mb-4 contact-card d-flex flex-column ">
              <Form.Label className="lable " htmlFor="basic-url">
                  Full Name 
              </Form.Label>
        
              <InputGroup className="mb-1">
                <Form.Control
                  className="custom-placeholder"
                  id="basic-url"
                  name="fullName"
                   value={formData.fullName}
                    onChange={(e) =>
                    setFormData({ ...formData, fullName: e.target.value })
                  }
                  placeholder="Your Name"
                  aria-describedby="basic-addon3"
                  autoComplete="off"
                />
              
              </InputGroup>
              <Form.Label className="lable mt-2" htmlFor="basic-url">
                  Email 
              </Form.Label>
        
              <InputGroup className="mb-2">
                <Form.Control
                  className="custom-placeholder"
                  id="basic-url"
                  name="email"
                   value={formData.email}
                    onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="Enter Email"
                  aria-describedby="basic-addon3"
                  autoComplete="off"
                />
              
              </InputGroup>
               {/* <Form.Label className="lable mt-2" htmlFor="basic-url">
                 message 
              </Form.Label>
        
              <InputGroup className="mb-3">
                <Form.Control
                  className="custom-placeholder"
                  id="basic-url"
                  name="fullName"
                  
                  placeholder="Your Name"
                  aria-describedby="basic-addon3"
                 
                  autoComplete="off"
                />
              
              </InputGroup> */}
               <Form.Label className="lable" htmlFor="basic-url">
                Message 
              </Form.Label>
              <InputGroup>
                <Form.Control
                  className="custom-placeholder"
                  placeholder="Type Your Message"
                  name="message"
                   value={formData.message}
                    onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
           }
                  as="textarea"
                  aria-label="With textarea"
                  style={{ height: "90px" }}
                />
              </InputGroup>
                <button className="play-btn  mt-3" onClick={handleSubmit}>Submit</button>
            </div>
            {/* <div className='mb-5'>
            <Adsense slot="6300978111"/>
            </div> */}
            </div>
             <div className={`toast-container-custom ${show ? "show" : ""}`}>
          <Toast
            onClose={() => setShow(false)}
            show={show}
            delay={3000}
            autohide
            bg="success"
          >
            <Toast.Header closeButton={true}>
              <strong className="me-auto">Success</strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              Form submitted successfully!
            </Toast.Body>
          </Toast>
        </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
